<template>
  <div class="input_box" :class="[theme, focus && 'focus']">
    <slot name="prefix"> </slot>
    <input
      ref="inputRef"
      class="input_area"
      :class="[$store.state.isMirroring && 'mirror']"
      v-model="curValue"
      :type="type"
      :placeholder="placeholder"
      :inputmode="inputmode"
      :maxlength="maxLength"
      :minlength="minLength"
      :readonly="readonly"
      :disabled="disabled"
      autocomplete="off"
      @blur="handleBlur"
      @focus="handleFocus"
      @input="handleInput"
    />
    <img
      v-if="showClear && curValue"
      class="clear_icon"
      src="@/assets/clear_icon.png"
      alt=""
      @touchend.stop.prevent="clear"
    />
    <slot> </slot>
  </div>
</template>

<script>
export default {
  name: 'CommonInput',
  data() {
    return {
      curValue: '',
      focus: false
    }
  },
  props: {
    value: String,
    type: String,
    placeholder: String,
    inputmode: String,
    maxLength: Number | String,
    minLength: Number | String,
    autoFocus: {
      type: Boolean,
      default: false
    },
    onBlur: Function,
    onFocus: Function,
    onInput: Function,
    theme: {
      type: 'white' | 'primary',
      default: 'primary'
    },
    showClear: {
      type: Boolean,
      default: false
    },
    readonly: {
      type: Boolean,
      default: false
    },
    disabled: {
      type: Boolean,
      default: false
    }
  },
  watch: {
    value(val) {
      this.curValue = val
    },
    curValue(val) {
      this.updateValue(val)
    },
    autoFocus(val) {
      if (val) {
        this.$nextTick(() => {
          this.$refs.inputRef.focus()
        })
      }
    }
  },
  methods: {
    updateValue() {
      this.$emit('input', this.curValue)
    },
    handleBlur() {
      this.focus = false
      if (this.onBlur) {
        this.onBlur()
      }
    },
    handleFocus() {
      this.focus = true
      if (this.onFocus) {
        this.onFocus()
      }
    },
    handleInput(event) {
      if (this.onInput) {
        this.onInput(event)
      }
    },
    clear() {
      this.curValue = ''
      this.updateValue()
    }
  },
  mounted() {
    this.curValue = this.value
    if (this.autoFocus) {
      this.$nextTick(() => {
        this.$refs.inputRef.focus()
      })
    }
  }
}
</script>

<style scoped>
.input_box {
  width: 100%;
  padding: 0.1rem 0.16rem;
  box-sizing: border-box;
  display: flex;
  align-items: center;
  border-radius: 0.08rem;
  height: 0.48rem;
  border: 0.01rem solid transparent;
}

.input_box.primary {
  background: linear-gradient(90deg, rgba(67, 215, 125, 0.15) 0%, rgba(63, 187, 112, 0.15) 100%);
}

.input_box.white {
  background: #fff;
  border: 0.01rem solid #d6d6d6;
}

.input_box.focus {
  border: 0.01rem solid #3fbb70;
}

.input_area {
  color: #2f2f2f;
  font-size: 0.14rem;
  line-height: 0.14rem;
  text-align: left;
  height: 0.48rem;
  background: transparent;
  width: 100%;
  flex: 1;
  min-width: 0;
  caret-color: #3fbb70;
  font-weight: 600;
}

.input_area::placeholder {
  color: #828282;
  font-weight: 400;
}

.input_area.mirror {
  text-align: right;
}

.clear_icon {
  width: 0.2rem;
  height: 0.2rem;
}
</style>



// WEBPACK FOOTER //
// src/components/CommonInput.vue